<template>
  <!-- The small form of the one loader (Loader.vue), for buttons: shows at once. -->
  <Loader
    :color="color"
    immediate
    small
  />
</template>

<script>
import Loader from '@components/Loader'

export default {
  components: {
    Loader
  },
  props: {
    color: {
      type: String,
      default: 'text-secondary'
    }
  }
}
</script>
